import { observer } from "mobx-react";

import { useStores } from "@packages/store";

import { useEntranceTestCheck } from "@/hooks/useEntranceTestCheck";
import { usePromocodeAndConfirmation } from "@/hooks/usePromocodeAndConfirmation";
import { useTokenCheck } from "@/hooks/useTokenCheck";

export const AuthGuard = observer(function AuthGuard() {
  const { auth, api } = useStores();

  usePromocodeAndConfirmation(auth, api);
  useEntranceTestCheck(auth);
  useTokenCheck(auth);

  return null;
});
